import React, {useContext, useState} from "react";
import SimpleDialog from "../dialog/SimpleDialog";
import {LanguageContext} from "../../context/LanguageContext";
import {Typography} from "@mui/material";
import PropTypes from "prop-types";
import {useAuth} from "oidc-react";

const LogoutDialog = (props) => {
  const auth = useAuth();
  const languageContext = useContext(LanguageContext);
  const [loading, setLoading] = useState(false);

  const handleBtnClick = () => {
    setLoading(true);
    auth.userManager.signoutRedirect();
  };

  return (
    <div style={{zIndex: 2001}}>
      <SimpleDialog
        handleClose={props.handleClose}
        open={props.open}
        title={languageContext.dictionary.applyChanges}
        blocking
        newDesign
        maxWidth={"md"}
        loading={loading}
        buttonProps={{
          ok: {title: languageContext.dictionary.logout, onClick: handleBtnClick}
        }}
      >
        <Typography sx={{paddingBottom: 1}}>
          {languageContext.dictionary.logoutDialogContent}
        </Typography>
      </SimpleDialog>
    </div>
  );
};

LogoutDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default LogoutDialog;
